import StatisticsBar from '@/components/StatisticsBar';
import React from 'react';

interface IStatsItem {
  drawNumber: number;
  count: number;
}

export interface LottoStatisticsDrawNumberProps {
  isLoading: boolean;
  stats: IStatsItem[];
  children?: React.ReactNode;
}

export class LottoStatisticsDrawNumber extends React.Component<LottoStatisticsDrawNumberProps> {
  private get maxCount(): number {
    return !this.props.isLoading
      ? Math.max(...this.props.stats.map((count) => count.count))
      : 1;
  }

  render() {
    return (
      <div className="LottoStatistics__barContainer">
        {this.props.stats.map((item) => {
          return (
            <StatisticsBar
              key={item.drawNumber}
              label={item.drawNumber.toString()}
              value={item.count}
              maxValue={this.maxCount}
              lottoBall={true}
              isLoading={this.props.isLoading}
            />
          );
        })}
      </div>
    );
  }
}
